import { Observable } from "rxjs";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import {
  BulkAction,
  ModalService,
  DataService,
} from "@bb-vendure/admin-ui/core";
import {
  DeleteNoticeDocument,
  DeleteNoticeMutation,
} from "../generated-graphql/graphql";

const deleteNoticeBulkAction: BulkAction = {
  location: "notice-table",
  label: "Delete Selected Notice",
  icon: "trash",
  iconClass: "is-danger",
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    modalService
      .dialog({
        title: "Delete Selected Notice",
        body: `Are you sure you want to delete ${selection.length} notice?`,
        buttons: [
          { type: "secondary", label: "Cancel" },
          { type: "primary", label: "Delete", returnValue: selection },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables: Observable<DeleteNoticeMutation>[] = [];
          for (const item in result) {
            deleteObservables.push(
              dataService.mutate(DeleteNoticeDocument, {
                id: result[item].id,
              })
            );
          }
          forkJoin(deleteObservables).subscribe(() => {
            hostComponent.refresh();
            clearSelection();
          });
        }
      });
  },
};

export { deleteNoticeBulkAction };
